<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Comarca:"
    id="selectComarca"
    placeholder="Selecione a(s) Comarca(s)"
    :multiple="true"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import ComarcaRepository from '@/shared/http/repositories/configurations/comarca.js'

export default {
  name: 'NxSelectAjuizamentoComarca',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadComarcas()
  },
  methods: {
    onLoadComarcas () {
      ComarcaRepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.id, 'text': x.nome}))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Comarcas', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectAjuizamentoComarca.vue